// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PurchaseOrderChangeRecords model should have correct belongsTo relations 1`] = `
Array [
  "PurchaseOrder",
  "User",
]
`;
